/**
 * Default ordering for the scheduler's two lists — the jobs list and the teams
 * list — so they no longer render in the (effectively random) order the API
 * returns them (WRK-5718). Both sort A-Z by name/title, case-insensitively and
 * with natural numeric ordering ("Team 2" before "Team 10").
 */

// Case-insensitive, natural (numeric-aware) A-Z comparator shared by both lists.
const collator = new Intl.Collator(undefined, { sensitivity: 'base', numeric: true });

/** Returns a new array of teams ordered A-Z by name. Does not mutate the input. */
export function sortTeamsByName<T extends { name: string }>(teams: T[]): T[] {
  return [...teams].sort((a, b) => collator.compare(a.name, b.name));
}

/**
 * Returns a new array of jobs ordered A-Z by title. Does not mutate the input.
 * Jobs flagged `isNew` (just scheduled) are kept ahead of the rest so the
 * highlight stays at the top, with A-Z applied within each group.
 */
export function sortJobsByTitle<T extends { title: string; isNew?: boolean }>(jobs: T[]): T[] {
  return [...jobs].sort((a, b) => {
    if (a.isNew !== b.isNew) return a.isNew ? -1 : 1;
    return collator.compare(a.title, b.title);
  });
}
